<div class="cowing-input-container">
  <input #input [type]="'range'" [(ngModel)]="value" (input)="onInputChange($event)" />
</div>